module.exports = __webpack_public_path__ + "static/media/blog.afd87614.jpg";